export var FETCH_UNSETTLED_BETS = 'FETCH_UNSETTLED_BETS';
export var SUCCESS_FETCH_UNSETTLED_BETS = 'SUCCESS_FETCH_UNSETTLED_BETS';
export var FAILURE_FETCH_UNSETTLED_BETS = 'FAILURE_FETCH_UNSETTLED_BETS';
export var FETCH_UNSETTLED_BETS_DETAILS = 'FETCH_UNSETTLED_BETS_DETAILS';
export var SUCCESS_FETCH_UNSETTLED_BETS_DETAILS = 'SUCCESS_FETCH_UNSETTLED_BETS_DETAILS';
export var FAILURE_FETCH_UNSETTLED_BETS_DETAILS = 'FAILURE_FETCH_UNSETTLED_BETS_DETAILS';



// WEBPACK FOOTER //
// ./src/actions/unsettled-bets/unsettledBets.js